// ======== core Vue
import Vue from "vue";

// ======== Main app
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
// ======== Router
import router from "./router";

// ======== Store
import store from "./store";
import "@/plugins";
// ======== language
store.dispatch("lang_module/handleLang"); // ==> Store (Vuex) <==
store.dispatch("theme_module/handleTheme"); // ==> Store (Vuex) <==

// **** CONSTS
// const USER_TOKEN = store.getters["auth_module/currentUser"].token;
const CURRENT_LANG = store.getters["lang_module/lang"];

import MainFilter from "@/components/Filters/MainFilter.vue";
// Set Token If Exists

// ======== vue-particles
import VueParticles from "vue-particles";
Vue.use(VueParticles);

// ======== iziToast
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
Vue.prototype.$iziToast = iziToast; // Glopal variable
Vue.use(iziToast);

// ======== VueLazyload
// import VueLazyload from "vue-lazyload";
// import loaderGIF from "./assets/images/loader.gif";
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: loaderGIF,
//   loading: loaderGIF,
//   attempt: 1,
// });

// ======== Moment
const moment = require("moment");
if (CURRENT_LANG == "ar") {
  require("moment/locale/ar");
}
Vue.use(require("vue-moment"), {
  moment,
});

// ======== AOS
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

// ======== i18n
import i18n from "./i18n";

import VueCarousel from "vue-carousel";

Vue.use(VueCarousel);

import VueDatetimeJs from "vue-datetime-js";
Vue.use(VueDatetimeJs, {
  name: "custom-date-picker",
  props: {
    inputFormat: "YYYY-MM-DD HH:mm:ss",
    format: "YYYY-MM-DD HH:mm:ss",
    editable: false,
    inputClass: "form-control my-custom-class-name",
    placeholder: "حدد الوقت والتاريخ",
    altFormat: "YYYY-MM-DD HH:mm:ss",
    color: "#00acc1",
    autoSubmit: false,
    //...
    //... And whatever you want to set as default
    //...
  },
});

// =============> Multiselect
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);
// =============> tree
// import the component
// import Treeselect from "@riophae/vue-treeselect";
// import the styles
// import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// Vue.component("treeselect", Treeselect);

// ========  Main Style
import "./assets/scss/main.scss";

// =============> Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: "AIzaSyDRymdCLWxCwLHFnwv36iieKAMjiwk8sdc",
    libraries: "places", // This is required if you use the Auto complete plug-in
  },
});
import BaseInput from "./components/Forms/BaseInput.vue";
Vue.component("base-input", BaseInput);
// ============> Ckeditor
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);
// import VueEditor from "vue2-editor";
// import Quill from "quill/core";
// Vue.use(VueEditor);
// import CKEditorVideo from '@ckeditor/ckeditor5-vue2'
// Vue.use(CKEditorVideo)
// vue tags inputs
// import VueTagsInput from "@johmun/vue-tags-input";
// Vue.component("vue-tags-input", VueTagsInput);
// START:: IMPORTING VUE APEX CHARTS
import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts);
Vue.use(VueApexCharts);
// END:: IMPORTING VUE APEX CHARTS

// =========== Start Import && Register Global Components ===========
import Breadcrumb from "./components/Global/Breadcrumb.vue";
import ProfileCard from "./components/Global/ProfileCard.vue";
import Statistics from "./components/Global/Statistics.vue";

import BaseModel from "./components/UI/BaseModel.vue";
import BaseMap from "./components/Maps/BaseMap.vue";
import BaseCard from "./components/UI/BaseCard.vue";

import Deleter from "@/components/Modals/Deleter.vue";

import UplodeWithoutHover from "./components/Uploads/UploadWithoutHover.vue";
import UplodeImage from "./components/Uploads/UplodeImage.vue";
import UplodeVideo from "./components/Uploads/UplodeVideo.vue";
import UplodeMultiple from "./components/Uploads/UplodeMultiple.vue";
import UplodeMultiples from "./components/Uploads/UplodeMultiples.vue";
import NotFound from "./components/Global/not-found";

import BaseSelectInput from "./components/Forms/BaseSelectInput.vue";

// import BaseSelectInput from './components/Forms/BaseSelectInput.vue'
// START:: Main Loader
import MainLoader from "@/components/Loaders/MainLoader.vue";
// END:: Main Loader

Vue.component("MainLoader", MainLoader);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("profile-card", ProfileCard);
Vue.component("base-model", BaseModel);
Vue.component("base-map", BaseMap);
Vue.component("base-card", BaseCard);
Vue.component("main-filter", MainFilter);
Vue.component("uplode-image", UplodeImage);

Vue.component("uplode-video", UplodeVideo);
Vue.component("base-select-input", BaseSelectInput);
Vue.component("deleter", Deleter);
Vue.component("uplode-without-hover", UplodeWithoutHover);
Vue.component("uplode-multiple", UplodeMultiple);
Vue.component("uplode-multiples", UplodeMultiples);
Vue.component("stats-card", Statistics);
Vue.component("NotFound", NotFound);
// =========== End Import && Register Global Components ===========
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
// =========== Mixins
import helpers from "./Mixins/helpers";
Vue.mixin(helpers);
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);
import Permission from "@/helpers/permission";
Vue.prototype.$permission = new Permission();

// ======== Attatch and Mount
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
